import { render, staticRenderFns } from "./ExclusionTable.vue?vue&type=template&id=80359a70&scoped=true"
import script from "./ExclusionTable.vue?vue&type=script&lang=js"
export * from "./ExclusionTable.vue?vue&type=script&lang=js"
import style0 from "./ExclusionTable.vue?vue&type=style&index=0&id=80359a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80359a70",
  null
  
)

export default component.exports